import { useContext } from 'react'
import PropTypes from 'prop-types'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { DashboardModule, Form, SectionDivider } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import ToggleListItem from '@components/ToggleListItem'
import EntitySelector from '@components/EntitySelector'

import { generateUrls } from '@hooks/useProviderPriceList'

import { toggleNestedValue } from '@functions/entity'

import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'

const handleUpdatePublication = (entityState, updatePublication, updateFn) => {
  const updatePublicationPayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: entityState,
    requestOptions: defaultRequestOptions.publication,
    toastText: 'Publication Updated',
  }

  updatePublication(updatePublicationPayload)
}

const PublicationSettings = (props) => {
  const { publicationForm, publicationPayload } = props

  const {
    callbacks: { updatePublication: updateFn },
    publication: { provider_id },
  } = publicationPayload

  const pageContext = useContext(PageContext)
  const {
    callbacks: { updatePublication },
  } = pageContext

  const {
    entityState: {
      features: { editorial, ofi },
      options: { disable_preflight },
      provider_price_list_id,
    },
    errors,
  } = publicationForm

  const { editProviderPriceListUrl } = generateUrls({ id: provider_price_list_id })

  return (
    <DashboardModule title="Publication Settings">
      <Form padding="large" boxProps={{ paddingBottom: 'medium' }}>
        <EntitySelector
          callbacks={{
            selectItem: priceList => handleUpdatePublication(
              { provider_price_list_id: priceList ? priceList.id : null },
              updatePublication,
              updateFn,
            ),
          }}
          endpoint="provider_price_lists"
          entityKey="providerPriceLists"
          errorMessage={errors.provider_price_list_id}
          goToHref={`${editProviderPriceListUrl}?redirect=${generateRedirectUrl()}`}
          label="Price list"
          searchRequestOptions={{ provider_id }}
          selectedItemId={provider_price_list_id}
        />

        <SectionDivider boxProps={{ marginY: 'medium' }}>FEATURES</SectionDivider>

        <ToggleListItem
          onClick={() => handleUpdatePublication(
            toggleNestedValue(publicationForm, 'options.disable_preflight'),
            updatePublication,
            updateFn,
          )}
          toggleValue={!disable_preflight}
        >
          <ToggleListItem.Title>Preflight</ToggleListItem.Title>
          <ToggleListItem.Description>
            Publication bookings will show in News Desk for preflight
          </ToggleListItem.Description>
        </ToggleListItem>

        <ToggleListItem
          onClick={() => handleUpdatePublication(
            toggleNestedValue(publicationForm, 'features.ofi'),
            updatePublication,
            updateFn,
          )}
          toggleValue={ofi}
        >
          <ToggleListItem.Title>OFIs</ToggleListItem.Title>
          <ToggleListItem.Description>
            This publication will make OFI bookings available to the user
          </ToggleListItem.Description>
        </ToggleListItem>

        <ToggleListItem
          onClick={() => handleUpdatePublication(
            toggleNestedValue(publicationForm, 'features.editorial'),
            updatePublication,
            updateFn,
          )}
          toggleValue={editorial}
        >
          <ToggleListItem.Title>Editorials</ToggleListItem.Title>
          <ToggleListItem.Description>
            This publication will make editorial bookings available to the user
          </ToggleListItem.Description>
        </ToggleListItem>
      </Form>
    </DashboardModule>
  )
}

PublicationSettings.propTypes = {
  publicationForm: PropTypes.object.isRequired,
  publicationPayload: PropTypes.object.isRequired,
}

export default PublicationSettings
